import React, { useState , useEffect, useRef} from 'react';


import "@fontsource/mulish"; // Defaults to weight 400.

// import { Button } from '@next-components/button'; //'@next-components/cta';
import { write } from 'store/storages/cookieStorage';
import { faCarWash } from '@fortawesome/pro-regular-svg-icons';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { makeStyles } from '@mui/styles';

import { faHashtag } from "@fortawesome/pro-light-svg-icons";

import { faFileInvoice } from "@fortawesome/pro-light-svg-icons";

import InvoiceItem from './InvoiceItem';
import Filter from './Filter';

import {getFilteredInvoicesX} from './Utils';
import InvoiceListView from './InvoiceListView';

import {getConfigValue} from './Config';



const useStyles = makeStyles(theme => ({
 
  outerColumn: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    // margin: '10px',  
    fontSize: 14,    
    // backgroundColor: 'red'
    
   },
  
   topTextColumn: {        
    fontFamily:'Mulish', 
    fontWeight: '200',
    // backgroundColor: 'red',
    display:'flex',
    flexDirection: 'column',
    justifyContent:'flex-start',
    alignItems: 'flex-start',         
    paddingLeft: '5vw',  
    // paddingTop: '2vh',
    // paddingBottom: '2vh' ,
    minWidth: '200px',
    margin: '20px',          

},
   promptTextRow: {
    fontFamily:'Mulish', 
    fontWeight: '200',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: '#E2F8F7',
    width: '100vw',
   
  }, 
 
  imageRow: {
    // backgroundColor : 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    alignSelf: 'flex-end',
    
    maxWidth: '200px'

  }, 
  titleText: {
        
    fontSize: '12pt', 
    marginBottom: '2vh'

  },
  promptText: {
      fontSize: '8pt', 

  },
  linkedAccountsRow: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    flexFlow: 'wrap',
  
  },
  
 


}));



function InvoiceMainView(props) {
  
  var store = require('store')

  const [linkedAccounts, setLinkedAccounts] = useState();
  const [continuationTokens, setContinuactionTokens] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [fetchedJson, setFetchedJson] = useState();
  
  const controllerRef = useRef();
 
  
  
  const classes = useStyles();

  useEffect(() =>  { //run once
    // setCurrentRefresh(props.doRefresh);
    setLinkedAccounts(null); //reset
    setContinuactionTokens(null) //triggers fetching    
    
    fetchInvoicesChuncked();
  },[props.doRefresh])

  
  useEffect(() =>  { //run to fetch more chunks upon receiving continuation tokens
    
    if (continuationTokens)
      fetchInvoicesChuncked(continuationTokens, linkedAccounts);  
    
  },[continuationTokens])

  useEffect(() =>  { 
    if(fetchedJson) {//component is not refreshed since fetch started
      handleFetchedJson(fetchedJson);  
    }
   
  },[fetchedJson])


  const fetchInvoicesChuncked = async (continuationTokens, linkedAccounts) => {  

    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    const controller = new AbortController();
    controllerRef.current = controller;

    if (!linkedAccounts) //only show spinner on first fetch with no continuationToken
      setIsFetching(true);

    if (!continuationTokens)
      continuationTokens = {}; //create empty dictionary, server requires empty object

    const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Invoice/getInvoices/${store.get("sessionToken")}`, {
            signal: controllerRef.current?.signal,
            method: 'POST', // *GET, POST, PUT, DELETE, etc.          
            headers: {
              'Content-Type': 'application/json'             
            },            
            body: JSON.stringify(continuationTokens) // body data type must match "Content-Type" header
          }).catch(e => {
              // called on cancel
              console.log("successive fetch cancelled");             
        });

    controllerRef.current = null;
     
    if (res) {
      const json = await res.json();      
      setFetchedJson(json); 
    }

    
    setIsFetching(false);                    
  }

  const handleFetchedJson = (json) => {
    if(Array.isArray(json)){           
     

      if (!linkedAccounts) { //for first fetch, store resultSet (linkedAccounts)
        setLinkedAccounts(json);
        console.log("first fetch");
      }
      else {
        console.log("successive fetch");
        mergeResultSets(json); //for successive calls, merge new results into existing         
      }           
      
      //extract continuation tokens
      var hasTokens=false;
      var newContinuationTokens = {};
      json.map( (account) => {        
        if (account.ContinuationToken) {
          newContinuationTokens[account.ApiId]=account.ContinuationToken;
          hasTokens=true;
        }
      }
      );
     

      if (hasTokens) {  //one or more continuationTokens where supplied by the server, more invoices should be fetched
        setContinuactionTokens(newContinuationTokens);
      }
      else {
        setContinuactionTokens(null);
      }


    }
    else {
      console.log("json is not an array of account objects (customers)");
    }

  }

  //merges new invoice fetch results with existing results
  const mergeResultSets = (newResults) => { 
    const existingResults = [...linkedAccounts];

    newResults.map((newAccount) => {        
      existingResults.map((existingAccount) => {
        if (existingAccount.ApiId===newAccount.ApiId) {
            existingAccount.Invoices = existingAccount.Invoices.concat(newAccount.Invoices);
            // console.log("fetched invoices: ", newAccount.Invoices.length)
        }
      });        
    });

    setLinkedAccounts(existingResults);
  }


  

   

  return (  

    
    
    

      <div className={classes.outerColumn}>
        
        {!props.admin && //only show explaining text if not admin (normal users only)

          <div className={classes.promptTextRow}>
          
          <div className={classes.topTextColumn}>
            <div className={classes.titleText}> Mine Fakturaer </div>

            <div className={classes.promptText}> Velg en fakura under for detaljer og nedlasting </div>

          </div>

            <div className={classes.imageRow}>
              <img src={window.location.origin + '/img/cars.png'} alt={"carImage"} width='90%' height='90%'  /> 
            </div>

          </div>
       }
        

      <div className={classes.linkedAccountsRow}>

          { isFetching && <CircularProgress /> }

          {linkedAccounts && linkedAccounts.map((linkedAccount) =>             
             <InvoiceListView account ={linkedAccount} continuationTokens={continuationTokens} userName={props.userName} admin={props.admin}/>
          )}

      </div>
        

             
       
       
     </div>
 

    

  );
}






export default InvoiceMainView;
